import { DeleteClientBankAccountRequest, ApiResponse } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useDeleteBankAccount() {
  const [deleting, setDeleting] = useState(false);

  async function deleteBankAccount(params: DeleteClientBankAccountRequest): Promise<ApiResponse> {
    try {
      setDeleting(true);
      const res = await api.postDeleteClientBankAccount(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setDeleting(false);
    }
  }

  return { deleting, deleteBankAccount };
}
